export const discountResolver = (
  percentage: number,
  price: number,
  paymentTerm: number | string
) => {
  if (paymentTerm) {
    switch (paymentTerm) {
      case '1':
      case 1: {
        return Math.round((price * 100) / (100 - percentage)) - price;
      }
      case '12':
      case 12: {
        return Math.round(12 * ((price * 100) / (100 - percentage) - price));
      }
      default:
        return Math.round((price * 100) / (100 - percentage)) - price;
    }
  } else return Math.round((price * 100) / (100 - percentage)) - price;
};

export const calculateFinalYearlyDiscount = (monthlyPrice: number, discounts: number[]) => { 
  const yearlyPrice = monthlyPrice * 12;
  //calculate the price before discounts
  const priceBeforeDiscount = getPriceWithoutDiscount(yearlyPrice, discounts);
  return (priceBeforeDiscount - yearlyPrice) || 0;
}


export const discountResolverWithCouponCode = (
  discountPercentage: number,
  couponCodeDiscountPercentage: number,
  price: number
) => {
  const customerDiscount = discountPercentage * 0.01;
  const couponDiscount = couponCodeDiscountPercentage * 0.01;
  const priceWithoutCustomerDiscount = Math.round(
    (price * 12) / (1 - customerDiscount)
  );
  const priceWithoutCouponDiscount = Math.round(
    priceWithoutCustomerDiscount / (1 - couponDiscount)
  );
  const totalYearlyDiscount = Math.round(
    priceWithoutCouponDiscount * couponDiscount +
      priceWithoutCustomerDiscount * customerDiscount
  );
  return totalYearlyDiscount;
};

export const getPriceWithoutDiscount = (finalPrice: number, discounts: number[]) => {
  if (finalPrice && discounts?.length > 0) {
    return discounts.reduceRight((price, discount) => {
      return Math.round((100 * price) / (100 - discount));
    }, finalPrice);
  }
  
  return finalPrice;
};

const isBetween = (value: number, min: number, max: number) =>
  min <= value && max >= value;
export const getRoofConstructionRange = (value: number) => {
  if (isBetween(value, 0, 20)) {
    return '1';
  } else if (isBetween(value, 21, 40)) {
    return '2';
  } else if (isBetween(value, 41, 60)) {
    return '3';
  } else if (isBetween(value, 61, 80)) {
    return '4';
  } else if (isBetween(value, 81, 100)) {
    return '5';
  } else if (isBetween(value, 101, 120)) {
    return '6';
  } else if (value > 120) {
    return '7';
  }
  return '';
};
